import { render, staticRenderFns } from "./headView.vue?vue&type=template&id=5b88a937&scoped=true&"
import script from "./headView.vue?vue&type=script&lang=js&"
export * from "./headView.vue?vue&type=script&lang=js&"
import style0 from "./headView.vue?vue&type=style&index=0&id=5b88a937&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88a937",
  null
  
)

export default component.exports